import React from 'react'

import AS from './AI_Images/academic_supplies.jpg';
import BP from './AI_Images/bag_pack.jpg';
import BD from './AI_Images/bedroom.jpg';
import BL from './AI_Images/binders.jpg';
import FD from './AI_Images/flash_drive.jpg';
import FLD from './AI_Images/folders.jpg';
import HLT from './AI_Images/highlighters.jpg';
import NB from './AI_Images/note_book.jpg';
import NC from './AI_Images/note_cards.jpg';
import PP from './AI_Images/papers.jpg';
import PNC from './AI_Images/pencils.jpg';
import PLN from './AI_Images/planner.jpg';
import PRN from './AI_Images/printer.jpg';
import SCS from './AI_Images/scissors.jpg';
import STP from './AI_Images/stapler.jpg';
import STN from './AI_Images/sticky_notes.jpg';
import TPE from './AI_Images/tape.jpg';
import TB from './AI_Images/text_books.jpg';

import CC from './AI_Images/calculator.jpg';
import PPCL from './AI_Images/paper_clips.jpg';
import PEN from './AI_Images/pen.jpg';
import HP from './AI_Images/Head_phones.jpg';

function More() {

    const array = [
    {
        'item':'flash drive',
        'image': FD
    },

      {
        'item':'Bag Pack',
        'image': BP
    },

      {
        'item':'HighLighters',
        'image': HLT
    },

      {
        'item':'Paper',
        'image': PP
    },

      {
        'item':'Printer',
        'image': PRN
    },

      {
        'item':'Tape',
        'image': TPE
    },

      {
        'item':'Notebooks',
        'image': NB
    },

      {
        'item':'Binders',
        'image': BL
    },

      {
        'item':'Planner',
        'image': PLN
    },

      {
        'item':'Sticky Notes',
        'image': STN
    },

      {
        'item':'Scissors',
        'image': SCS
    },

      {
        'item':'Textbooks',
        'image': TB
    },

      {
        'item':'Pencils',
        'image': PNC
    },

      {
        'item':'Folders',
        'image': FLD
    },

      {
        'item':'Note Cards',
        'image': NC
    },

      {
        'item':'Bedroom items',
        'image': BD
    },

      {
        'item':'Stapler',
        'image': STP
    },

      {
        'item':'Academic supplies',
        'image': AS
    },


      {
        'item':'Calculator',
        'image': CC
    },

      {
        'item':'Head Phones',
        'image': HP
    },

      {
        'item':'Paperclips',
        'image': PPCL
    },

      {
        'item':'Pens',
        'image': PEN
    },


]
  return (
    <div className='AI_MORE'>
        {array.map((comment, index) => (
        <div key={index} className='more_inner'>
            <div className='item_img_div'>
                <img src={comment.image} />
            </div>
            <div className='item_text'>{comment.item}</div>
        </div>
        ))}
    </div>
  )
}

export default More